import { Route, Routes } from 'react-router-dom'
import React from 'react'
import RunInformation from './RunInformation'
import DriverRunsContainer from './DriverRunsContainer'

const MobileUserContainer = ({ parameters }) => {
    return (
        <Routes>
            <Route
                path="/run/:id"
                element={<RunInformation parameters={parameters} />}
            />
            <Route path="/" element={<DriverRunsContainer />} />
        </Routes>
    )
}

export default MobileUserContainer
